import * as types from '../actionType'

const initialState = []

const newAddress = (state = initialState, action) => {
    switch (action.type) {
        case types.ADD_ADDRESS:
            return action.payload
        default:
            return state
    }
}

export {newAddress};